
export const SECURITY_CONFIG = {
  MAX_INPUT_LENGTH: 10000,
  SESSION_TIMEOUT_MINUTES: 120,
  MAX_LOGIN_ATTEMPTS: 5,
  PASSWORD_MIN_LENGTH: 8,
} as const;

export const VALIDATION_PATTERNS = {
  UUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  SAFE_HTML: /<script[^>]*>.*?<\/script>/gi,
  SQL_INJECTION: /(\b(SELECT|INSERT|UPDATE|DELETE|DROP|CREATE|ALTER|EXEC)\b)/gi,
} as const;

export const ROUTE_PERMISSIONS = {
  PUBLIC_ROUTES: ['/auth', '/landing', '/', '/not-found'],
  AUTHENTICATED_ROUTES: ['/dashboard', '/session', '/account', '/requests'],
  PREMIUM_ROUTES: ['/coach-progress', '/technique-analysis'],
  ADMIN_ROUTES: ['/admin'],
} as const;

export const RLS_POLICIES = {
  OWNER_ONLY: 'auth.uid() = user_id',
  THREAD_OWNER: 'auth.uid() IN (SELECT user_id FROM public.threads WHERE id = thread_id)',
} as const;

export const SUBSCRIPTION_FEATURES = {
  FREE: [
    'basic_roleplay',
    'session_summaries',
    'persona_library_basic'
  ],
  PREMIUM: [
    'basic_roleplay',
    'advanced_roleplay',
    'mentor_feedback',
    'session_summaries',
    'persona_library_full',
    'session_analytics',
    'coach_progress',
    'technique_analysis',
    'supervision_features'
  ]
} as const;
